import React from "react";
import { WifiOff } from "lucide-react";
import useOnlineStatus from "../lib/useOnlineStatus";

/** Slim banner shown only when the device is offline. Designed to sit
 *  flush below the sticky header (Layout renders it inside main content). */
export default function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      data-testid="offline-banner"
      role="status"
      aria-live="polite"
      className="bg-[hsl(var(--parchment))] border-b border-gold/40 text-navy/80 text-[12px] py-2 px-4 flex items-center justify-center gap-2"
    >
      <WifiOff className="w-3.5 h-3.5 text-gold" />
      <span>
        Você está offline. Continuamos funcionando com o que já foi baixado.
      </span>
    </div>
  );
}
